import { PaymentMethodsCommandNames } from '@chegg/commerce-utils';
import { saveUserAddressCommands } from '../../CommandState/CommandState.actions';
import { setEditableMop } from '../../MopOnFileState/MopOnFileState.actions';
import { resetRecurlyPaymentForm } from '../../PaymentState/PaymentState.actions';
/**
 * resetForm - reset the payment and user address form
 */
export var resetForm = function resetForm(hostedFieldsService, dispatch) {
  dispatch(saveUserAddressCommands([{
    commandName: PaymentMethodsCommandNames.RESET_FIELDS
  }]));
  dispatch(setEditableMop({
    mop: null
  }));
  if (hostedFieldsService) {
    if (hostedFieldsService.isInitialized) {
      hostedFieldsService.resetForm();
    } else {
      // when resetForm is called against a torn down hosted fields instance, reinitialize it.
      hostedFieldsService.initialize();
    }
  }
};

/**
 * resetRecurlyForm - reset the Recurly payment form
 */
export var resetRecurlyForm = function resetRecurlyForm(dispatch) {
  // sets rendersRecurlyForm to false to remove the CC elements
  // CC elements are re-rendered in CreditCardForm
  dispatch(resetRecurlyPaymentForm());
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/helpers/resetForm.js
// module id = 498
// module chunks = 11